import React from 'react';
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import EmailIcon from '@material-ui/icons/Email';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PropTypes from 'prop-types';
import AddIcon from '@material-ui/icons/Add';
import Skeleton from '@material-ui/lab/esm/Skeleton';
import { Box, TextField, Divider } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Footer from '../Complements/Footer';
import moment from 'moment'

//TEST

import Voucher from './Voucher';


const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    root2: {
      backgroundColor: theme.palette.background.paper,
      width: 500,
      position: 'relative',
      minHeight: 300,
    },
    paper: {
      height: 500,
      width: 400,
    },
    control: {
      padding: theme.spacing(2),
    },
    card: {
        height: 500,
        width: 400,
        maxWidth: 345,
      },
    card2: {
      height: 100,
      width: 100,
      maxWidth: 345,
    },
      media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
      },
      expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      },
      expandOpen: {
        transform: 'rotate(180deg)',
      },
      avatar: {
        backgroundColor: 'rgb(0, 160, 175)',
      },
      fab: {
        position: 'absolute',
        bottom: theme.spacing(5),
        right: theme.spacing(2),
      },
      rowIcon: {
        top: '40%'
      },
      titleDark: {
        color: 'rgb(0, 0, 1)',
        fontWeight: 'bold',
        fontSize: '0.875rem'
      },
      titleLight: {
        color: 'rgb(0, 0, 1)',
        fontSize: '0.875rem'
      },
      titleGreenBlackPrimary: {
        color: '#000000',
        fontWeight: 'bold',
        fontSize: '1.05rem'
      },
      titleGreenBlackSecondary: {
        color: '#000000',
        fontWeight: 'bold',
        fontSize: '1rem'
      }
  }));

const Transfers = props => {
    const classes = useStyles();
    const {  user, openBeneficiaryList, beneficiarySelected, transferForm, dialogOTP,
        openDialogBeneficiaryForm, balances, accountSelected, changeAccount, isviewvoucher, responseservertransfer, handleDownloadVoucher, numberdocumento, handleDownloadDevice, handleConvertMask, onActionAfter, AuthorizedTransactions } = props
    const { owner, name, accname, number, type_name } = beneficiarySelected
    const { Monto, NumeroCuentaDestino, Fecha, Email } = responseservertransfer;
        return (
        <div>
            <Grid container className={classes.root}  justify="center" alignItems="center">
                <Grid item xs={12}>
                    <Grid container  spacing={5}>
                        <Grid  item xs={12} md={6} lg ={6} 
                            >
                            <Card className={classes.card}>
                                <CardHeader
                                    avatar={
                                    <Avatar aria-label="recipe" className={classes.avatar}>
                                        { user ? user.Nombres.charAt(0) : <Skeleton variant="circle" width={40} height={40} />}
                                    </Avatar>
                                    }
                                    
                                    title={ <span className = {classes.titleDark}>
                                            {
                                                user ? 
                                                (user.EsPersonaNatural === true) ? `${user.Nombres} ${user.Apellidos} ` : user.RazonSocial : 
                                                <Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />
                                            }
                                            </span> }
                                    subheader={ 
                                        <span className = {classes.titleLight}>
                                            {
                                                balances ? `${accountSelected.Tipo} - ${accountSelected.Codigo}` : <Skeleton height={10} width="40%" />
                                            }
                                        </span>
                                        }
                                />
                                <Divider></Divider>
                                <br></br>
                                    <Autocomplete
                                        id="combo-box-demo"
                                        className = {classes.titleLight}
                                        value = { accountSelected }
                                        options={balances}
                                        onChange = { (e, nv) => {
                                            changeAccount(nv)
                                        }}
                                        disableClearable
                                        getOptionLabel={ (option) =>  `${option.Tipo} - ${option.Codigo}` }
                                        renderOption={(option) => (
                                        <React.Fragment>
                                            {`${option.Tipo} - ${option.Codigo}`}
                                        </React.Fragment>
                                        )}
                                        renderInput={(params) => <TextField {...params} label="Seleccione una cuenta"  variant="outlined" fullWidth/>}
                                    />
                                    <br></br>
                                    <Divider></Divider>
                                <CardContent>
                                    {
                                        user ?
                                        <List className={classes.root}>
                                            <ListItem button>
                                                <ListItemAvatar >
                                                <Avatar style = { { backgroundColor: 'rgb(0, 153, 168)' }}>
                                                    { user ? <LocalAtmIcon /> : <Skeleton variant="circle" width={40} height={40} />}
                                                </Avatar>
                                                </ListItemAvatar>
                                                {
                                                    user ?
                                                    <ListItemText
                                                        
                                                        primary={
                                                            <span className = { classes.titleGreenBlackPrimary}>
                                                                Saldo Disponible
                                                            </span>
                                                        }
                                                        secondary={
                                                            <span className = { classes.titleGreenBlackSecondary}>
                                                                {`$ ${accountSelected.SaldoCuenta}`}
                                                            </span>
                                                        } /> :
                                                    <ListItemText
                                                        primary = {<Skeleton variant="text" />}
                                                        secondary = {<Skeleton variant="text" />} />
                                                }
                                                
                                            </ListItem>
                                            <ListItem button>
                                                <ListItemAvatar>
                                                <Avatar>
                                                    { user ? <EmailIcon /> : <Skeleton variant="circle" width={40} height={40} />}
                                                </Avatar>
                                                </ListItemAvatar>
                                                {
                                                    user ?
                                                        <ListItemText
                                                            primary={"Correo Electrónico"}
                                                            secondary={ user.CorreoElectronico } /> :
                                                        <Box pt={0.5}>
                                                            <Skeleton />
                                                            <Skeleton width="60%" />
                                                        </Box>
                                                }
                                                
                                            </ListItem>
                                        </List> :
                                        <div>
                                            <CardHeader
                                                avatar={
                                                <Avatar aria-label="recipe" >
                                                    <Skeleton variant="circle" width={40} height={40} />
                                                </Avatar>
                                                }
                                                title={ <Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />}
                                                subheader={  <Skeleton height={10} width="40%" />}
                                            />
                                            <CardHeader
                                                avatar={
                                                <Avatar aria-label="recipe" >
                                                    <Skeleton variant="circle" width={40} height={40} />
                                                </Avatar>
                                                }
                                                title={ <Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />}
                                                subheader={  <Skeleton height={10} width="40%" />}
                                            />
                                        </div>
                                    }
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid  item xs={12} md={6} lg={6} >
                            { (isviewvoucher === true && !AuthorizedTransactions ) ? 
                            <Voucher 
                                    amount = { Monto }
                                    titleheader = { "Valor transferido" }
                                    title = { "Transferencia exitosa!" }
                                    databodyone = {
                                        [
                                            {
                                                title : "Desde cuenta de:",
                                                value : user.Nombres + " " +user.Apellidos,
                                                order : 1
                                            },
                                            {
                                                title : "Cuenta de destino:",
                                                value : NumeroCuentaDestino,
                                                order : 2
                                            },
                                            {
                                                title : "No. transferencia:",
                                                value : numberdocumento,
                                                order : 3
                                            },
                                            {
                                                title : "Fecha:",
                                                value : moment(Fecha).format("YYYY/MM/DD"),
                                                order : 4
                                            },
                                            {
                                                title : "Email",
                                                value : (Email) ? Email : "",
                                                order : 5
                                            },
                                        ]
                                    }
                                    textButtonCancel = {"Nueva Transferencia"}
                                    handleCancel = {onActionAfter}
                                    handleDownloadVoucher = { handleDownloadVoucher }
                                    handleDownloadDevice = { handleDownloadDevice}
                                />
                                
                                :
                                <Card className={classes.card}>

                                {(beneficiarySelected.owner) && <CardHeader

                                        avatar={

                                        <Avatar aria-label="recipe" className={classes.avatar}>

                                                { owner ? name.charAt(0) : 'SN'}

                                            </Avatar>

                                        }

                                        action={

                                        <IconButton aria-label="settings">

                                            <MoreVertIcon />

                                        </IconButton>

                                        }

                                        title={ owner ? name : 'Seleccione un beneficiario'}

                                        subheader={ owner ? `${accname} - ${(type_name === "TARJETA DE CREDITO") ? handleConvertMask(number) : number}` : '---'}

                                    />}
                                    
                                    <CardContent>
                                        <Typography variant="body2" color="textSecondary" component="p"></Typography>
                                                { owner ?
                                                    transferForm
                                                :
                                                <List className={classes.root}>
                                                    <ListItem button onClick = { () => openBeneficiaryList() } >
                                                        <ListItemAvatar>
                                                            <Avatar>
                                                                <AccountCircleIcon />
                                                            </Avatar>
                                                        </ListItemAvatar>
                                                        <ListItemText primary="Seleccione Beneficiario" secondary="" />
                                                    </ListItem>
                                                    <ListItem button onClick = { () => openDialogBeneficiaryForm() } >
                                                        <ListItemAvatar>
                                                            <Avatar>
                                                                <AddIcon />
                                                            </Avatar>
                                                        </ListItemAvatar>
                                                        <ListItemText primary="Agregar Nuevo Beneficiario" secondary="" />
                                                    </ListItem>
                                                </List>
                                                }
                                                
                                    </CardContent>
                                    <CardActions >
                                        {/* <div className={classes.root2}>
                                        <Fab color="primary" aria-label="add" className={classes.fab} onClick = { () => openDialogBeneficiaryForm() }>
                                            <AddIcon />
                                        </Fab>
                                        </div> */}
                                    </CardActions>
                                </Card>
                            }
                            
                        </Grid>
                    </Grid>

                    <Footer />
                </Grid>
            </Grid>
            { dialogOTP }
        </div>
    );
};

Transfers.propTypes = {
    user: PropTypes.object.isRequired,
};

export default Transfers;